/* External dependencies */
import { gql } from '@apollo/client';

export const listWarehousesQuery = gql`
  query listWarehouses($input: ListWarehousesInput!) {
    listWarehouses(input: $input) {
      total
      warehouses {
        id
        city
        country
        createdDate
        address
        phone
        postcode
        region
        status
        updatedDate
      }
    }
  }
`;
